import React from 'react';

import Dividends from './Dividends';
import { getDividends } from '../../utils/api';

const DividendsPublic = props => <Dividends endpoint={getDividends} {...props} />

export default DividendsPublic
